import './App.css';

import { HashRouter, Switch } from 'react-router-dom';
import React from 'react';
import EmptyComponent from '../../../../global/empty-component/EmptyComponent';
import MachineTranslation from '../machine-translation/MachineTranslation';
import AwsAccount from '../aws-account/AwsAccount';
import { Route } from 'react-router';
import SubmenuSidebar from '../../../../global/submenu-sidebar/SubmenuSidebar';
import TerminologyBase from '../terminology-base/TerminologyBase';
import TranslationMemory from '../translation-memory/TranslationMemory';

const translationResourcesItems = [
  {
    title: 'Aws Account',
    href: '/translation-resources/aws-accounts',
    component: AwsAccount,
  },
  {
    title: 'Machine Translation',
    href: '/translation-resources/machine-translation',
    component: MachineTranslation,
  },
  {
    title: 'Translation Memory',
    href: '/translation-resources/translation-memory',
    component: TranslationMemory,
  },
  {
    title: 'Terminology Base',
    href: '/translation-resources/terminology-base',
    component: TerminologyBase,
  },
];

const App = () => {
  return (
    <HashRouter>
      <div className="d-flex h-100">
        <SubmenuSidebar
          title="Translation Resources"
          linkItems={translationResourcesItems}
          reloadingDataAllowed={false}
        />
        <div className="d-flex flex-column p-1 overflow-scroll flex-grow-1">
          <Switch>
            <Route exact path="/translation-resources" component={EmptyComponent} />
            {translationResourcesItems.map(item => {
              return <Route key={item.title} path={item.href} component={item.component} />;
            })}
          </Switch>
        </div>
      </div>
    </HashRouter>
  );
};

export default App;
